import { render, staticRenderFns } from "./plattransactiondetais.vue?vue&type=template&id=38ba856f&"
import script from "./plattransactiondetais.vue?vue&type=script&lang=js&"
export * from "./plattransactiondetais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports